<template>
    <component class="cursus-icon" :is="iconComponent" />
</template>

<script>
    import icons from '../../icons';

    export default {
        props: {
            name: String,
        },
        computed: {
            iconComponent() {
                return {
                    name: `icon-${this.name}`,
                    template: icons[this.name],
                }
            }
        },
    }
</script>
